import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LayoutState } from './layout.reducer';

export const selectLayoutState = createFeatureSelector<LayoutState>('layout');

// Individual selectors
export const selectSidebarVisible = createSelector(
  selectLayoutState,
  (state: LayoutState) => state.sidebarVisible
);

export const selectHeaderVisible = createSelector(
  selectLayoutState,
  (state: LayoutState) => state.headerVisible
);

export const selectFooterVisible = createSelector(
  selectLayoutState,
  (state: LayoutState) => state.footerVisible
);

// Combined selectors
export const selectLayoutVisible = createSelector(
  selectLayoutState,
  (state: LayoutState) => state.sidebarVisible && state.headerVisible && state.footerVisible
);

export const selectLayoutHidden = createSelector(
  selectLayoutState,
  (state: LayoutState) => !state.sidebarVisible && !state.headerVisible && !state.footerVisible
);

export const selectPartialLayoutVisible = createSelector(
  selectLayoutState,
  (state: LayoutState) => state.sidebarVisible || state.headerVisible || state.footerVisible
);

// Utility selectors
export const selectLayoutStateSummary = createSelector(
  selectLayoutState,
  (state: LayoutState) => ({
    sidebarVisible: state.sidebarVisible,
    headerVisible: state.headerVisible,
    footerVisible: state.footerVisible,
    allVisible: state.sidebarVisible && state.headerVisible && state.footerVisible,
    allHidden: !state.sidebarVisible && !state.headerVisible && !state.footerVisible
  })
);
